var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-base-container g-app-intro-animation tutorials"},[_c('eazy-heading',{attrs:{"page-name":'tutorials'}}),_c('div',{staticClass:"tutorial-tab",on:{"click":_vm.goToDashboardTutorial}},[_vm._v(" "+_vm._s(_vm.$t('dashboardTutorial'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }